import fetch from 'node-fetch';
import {ServicesErrors, SendDownloadLinksApi} from '../../constants';
import {determineErrorLevelForSentry, handleResponse} from '../../utils';
import * as Sentry from '@sentry/browser';

export function sendDownloadLinks(token: string): Promise<any> {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({token: token})
  };

  return fetch(SendDownloadLinksApi, requestOptions)
    .then(handleResponse)
    .catch((error) => {
      const errorLevel = determineErrorLevelForSentry(error);

      Sentry.configureScope((scope) => {
        scope.setLevel(errorLevel);
      })


      Sentry.addBreadcrumb({
        category: 'auth',
        message: 'Endpoint ' + SendDownloadLinksApi,
        data: {
          error: error,
          requestOptions,
        },
        level: errorLevel
      });
      Sentry.captureMessage(ServicesErrors.waoo.sendDownloadLinks, errorLevel);
      throw new Error(error.message);
    });
}
